<template>
  <div class="contents_wrapper">
    <Header :title="'会議室検索'" :isLoading="searching" />
    <div style="margin-top: -30px;" class="contents">
      <div class="search_criteria_main">
        <div class="search_criteria_text">
          会議室の条件を選択してください
          <br />
          <template v-if="matchedRooms && false">
            <label style="font-size:1.3em;font-weight:700;">{{matchedRooms.length}}件</label>の会議室が合致
          </template>
          <template v-if="matchedRooms && (matchedRooms.length > 50)">
            <br />
            <span style="color:#F00;">50件以下になるように変更して下さい。</span>
          </template>
          <template v-else-if="matchedRooms && (matchedRooms.length == 0 )">
            <br />
            <span style="color:#F00;">条件に合う会議室がありません。</span>
          </template>
          <template v-else-if="!canSelect">
            <br />
            <span style="color:#F00;">空室が見つかりませんでした。</span>
          </template>
          <template v-else>
            <br />
            <span style="color:#F00;">&nbsp;</span>
          </template>
        </div>
        <div v-if="attributes === null" class="search_criteria loading">読込中...</div>
        <div v-else-if="attributes.length === 0" class="search_criteria_holder">検索項目がありません。</div>
        <ul v-else class="search_criteria" :class="{loading:searching}">
          <template v-for="attribute in attributes">
            <li class="criteria_item" v-bind:key="attribute.id">
              <div class="serch_criteria_group">
                {{attribute.displayName}}&nbsp;
                <label
                  class="criteria-label"
                  v-if="attribute.type === 0"
                >
                  <u>単一</u>
                </label>
                <label class="criteria-label" v-else-if="attribute.type === 1">
                  <u>OR</u>
                </label>
                <label class="criteria-label" v-else-if="attribute.type === 2">
                  <u>AND</u>
                </label>
                <button
                  v-if="attribute.type === 3"
                  class="criteria_btn orand"
                  v-bind:class="{'active': criteria[attribute.id].type === 1}"
                  @click="toggleOrAnd(attribute.id, 1)"
                >OR</button>
                <button
                  v-if="attribute.type === 3"
                  class="criteria_btn orand"
                  v-bind:class="{'active': criteria[attribute.id].type === 2}"
                  @click="toggleOrAnd(attribute.id, 2)"
                >AND</button>
              </div>
              <template v-for="item in attribute.items">
                <button
                  v-bind:key="item.id"
                  @click="toggle(attribute, item.id)"
                  class="criteria_btn"
                  v-bind:class="{'active': criteria[attribute.id].selected.includes(item.id)}"
                >{{item.displayName}}</button>
              </template>
            </li>
          </template>
        </ul>
      </div>
      <ButtonGroup
        @next="search()"
        :loading="attributes === null || matchedRooms === null || searching"
      >
        <template
          v-if="matchedRooms && matchedRooms.length > 0 && matchedRooms.length <= 50 && canSelect"
        >
          <div class="criteria_bottom_btn_icon" :class="{loading:searching}">
            <img :src="$designResource.iconBack" alt />
          </div>
          <div class="criteria_bottom_btn_text">検索</div>
        </template>
      </ButtonGroup>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Header from "../components/Header.vue";
import ButtonGroup from "../components/ButtonGroup.vue";

import roomService from "../services/roomService";
import scheduleService from "../services/scheduleService";
import roomAttributeService from "../services/roomAttributeService";
import Store from "../store";
import loggerService from "../services/loggerService";

const store = new Store();

export default {
  components: {
    Header,
    ButtonGroup
  },
  data: function() {
    return {
      matchedRooms: null,
      attributes: null,
      criteria: store.roomCriteria || {},
      selectedTime: null,
      targetTime: null,
      searching: false,
      canSelect: true
    };
  },
  created: function() {
    loggerService.pageView("SearchCriteria");
    var _this = this;
    this.selectedTime = moment(Number(this.$route.query["targetTime"]));
    this.targetTime = this.$route.query["targetTime"];
    roomService.getRooms();
    roomAttributeService.getRoomAttributes().then(attributes => {
      _this.attributes = attributes;
      var criteriaTemp = {};
      for (var i = 0, count = _this.attributes.length; i < count; i++) {
        var attribute = _this.attributes[i];
        // 検索条件がない場合はtypeのみ初期値を設定両方選択可能な場合の初期値はOR(1)とする
        criteriaTemp[attribute.id] = _this.criteria[attribute.id] || {
          type: attribute.type === 3 ? 1 : attribute.type,
          selected: []
        };
        if (
          attribute.type === 0 &&
          (criteriaTemp[attribute.id].type === 2 ||
            criteriaTemp[attribute.id].type === 1)
        )
          criteriaTemp[attribute.id].type = 0;
        if (
          attribute.type === 1 &&
          (criteriaTemp[attribute.id].type === 0 ||
            criteriaTemp[attribute.id].type === 2)
        )
          criteriaTemp[attribute.id].type = 1;
        if (
          attribute.type === 2 &&
          (criteriaTemp[attribute.id].type === 1 ||
            criteriaTemp[attribute.id].type === 0)
        )
          criteriaTemp[attribute.id].type = 2;
        if (attribute.type === 3 && criteriaTemp[attribute.id].type === 0)
          criteriaTemp[attribute.id].type = 1;
      }
      _this.criteria = Object.assign({}, criteriaTemp);
    });
  },
  watch: {
    criteria: function(val) {
      var _this = this;
      store.roomCriteria = val;
      _this.canSelect = true;
      roomService.getMatchRooms(val).then(m => {
        _this.matchedRooms = m;
        loggerService.info(`matchedRooms ${m ? m.length : "null"}`);
      });
    }
  },
  methods: {
    next: function() {
      this.$router.push({
        path: `/result`,
        query: {
          roomFrom: this.$route.query["roomFrom"],
          targetTime: this.targetTime
        }
      });
    },
    search: function() {
      if (this.searching) return;

      var _this = this;
      _this.searching = true;
      // 選択されている時間が10分以下の場合は予約させずに選択画面に戻す
      var current = moment(new Date())
        .add(10, "m")
        .toDate();
      if (_this.selectedTime.toDate() < current) {
        this.$router.push({
          path: `/time`
        });
        return;
      }
      roomService.getMatchRooms(store.roomCriteria).then(function(res) {
        var rooms = res;
        var target = res.map(r => r.address);
        scheduleService
          .getSchedule(target, moment(new Date()), _this.selectedTime)
          .then(function(schedules) {
            _this.canSelect = false;
            schedules.forEach(sc => {
              var room = rooms.find(
                rm => rm.address.toUpperCase() === sc.userId.toUpperCase()
              );
              room.isNotBusy = sc.busyItems.length === 0;
              // 1件でも選択可能なものがあるかどうか判定
              if (!_this.canSelect) _this.canSelect = room.isNotBusy;
            });
            if (_this.canSelect) {
              store.searchResult = rooms;
              _this.next();
            }
            _this.searching = false;
          });
      });
    },
    toggleOrAnd: function(id, value) {
      if (this.searching) return;
      this.criteria = Object.assign({}, this.criteria, {
        [id]: Object.assign(this.criteria[id], { type: value })
      });
    },
    toggle: function(attribute, id) {
      if (this.searching) return;
      var currentSelected = this.criteria[attribute.id].selected;
      if (currentSelected.includes(id))
        currentSelected = currentSelected.filter(n => n !== id);
      else if (attribute.type === 0) currentSelected = [id];
      else currentSelected.push(id);
      this.criteria = Object.assign({}, this.criteria, {
        [attribute.id]: Object.assign(this.criteria[attribute.id], {
          selected: currentSelected
        })
      });
    }
  }
};
</script>

<style lang="scss">
.search_criteria_main {
  width: 100%;
  height: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  overflow-y: auto;
}
.search_criteria_text {
  line-height: 1.3;
  color: $txtColor;
  font-size: 18px;
  width: 100%;
  text-align: center;
}
.search_criteria {
  background-color: #fff;
  padding: 5px;
  box-shadow: 1px 1px 5px 0px rgba(97, 79, 67, 0.3);
  border-radius: 5px;
  height: calc(100% - 275px);
  margin: 20px auto;
  overflow-y: auto;
}
.search_criteria_holder {
  background-color: #fff;
  padding: 5px;
  font-size: 1.3rem;
  box-shadow: 1px 1px 5px 0px rgba(97, 79, 67, 0.3);
  border-radius: 5px;
  height: calc(100% - 275px);
  margin: 20px auto;
  overflow-y: auto;
}
.serch_criteria_group {
  font-size: 18px;
  padding: 5px 10px 0 3px;
}
.criteria-label {
  font-size: 0.8em;
  color: #555;
}
.criteria_btn {
  display: inline-block;
  margin: 5px;
  padding: 1px 3px;
  color: $btnColor;
  border-radius: 3px;
  font-size: 18px;
  background-color: #fff;
  border: 1px solid $btnColor;
}
.criteria_item {
  margin-bottom: 7px;
}
.criteria_btn.active {
  background-color: $btnColor;
  color: #fff;
}
.criteria_btn.orand {
  font-size: 15px;
}
.criteria_bottom_btn_icon {
  width: 40px;
  perspective: 500;
}
.criteria_bottom_btn_icon > img {
  width: 26px;
  transform: rotateY(180deg);
}
.criteria_bottom_btn_text {
  font-size: 18px;
}
</style>